export default "__VITE_ASSET__BCEt_fHG__"